/**
 * @module account.transformer
 */
import { companyFrom } from './company.transformer';

/**
 * Create base account data from user object. This includes values from both
 * the account's `user` + `company` models for convenience.
 *
 * @param {Object} user - comes from backend `user`
 * @return {Object}
 */
const accountFrom = (user = {}) => {
  // @ts-expect-error TS(2339): Property 'permissions' does not exist on type '{}'... Remove this comment to see the full error message
  const company = companyFrom(user.company);

  // If the user has no first or last name, use the email for name so that
  // functions requiring a list of names at least has a value.
  // @ts-expect-error TS(2339): Property 'firstName' does not exist on type '{}'.
  const name = user.firstName || user.lastName ? `${user.firstName} ${user.lastName}` : user.email;

  const account = {
    // @ts-expect-error TS(2339): Property 'id' does not exist on type '{}'.
    userId: user.id,
    // @ts-expect-error TS(2339): Property 'employeeId' does not exist on type '{}'.
    employeeId: user.employeeId,
    // @ts-expect-error TS(2339): Property 'userRoleId' does not exist on type '{}'.
    userRoleId: user.userRoleId,
    // @ts-expect-error TS(2339): Property 'hierarchy' does not exist on type '{}'.
    hierarchy: user.hierarchy,
    name,
    // @ts-expect-error TS(2339): Property 'firstName' does not exist on type '{}'.
    firstName: user.firstName,
    // @ts-expect-error TS(2339): Property 'lastName' does not exist on type '{}'.
    lastName: user.lastName,
    // @ts-expect-error TS(2339): Property 'email' does not exist on type '{}'.
    email: user.email,
    // @ts-expect-error TS(2339): Property 'preferredLanguage' does not exist on typ... Remove this comment to see the full error message
    lang: user?.preferredLanguage?.langISOCode,
    // @ts-expect-error TS(2339): Property 'preferredLanguage' does not exist on typ... Remove this comment to see the full error message
    langId: Number(user?.preferredLanguage?.id), // REFACTOR: prefer iso-code instead of id
    // @ts-expect-error TS(2339): Property 'avatar' does not exist on type '{}'.
    avatarUrl: user.avatar,
    // @ts-expect-error TS(2339): Property 'worktangoAdmin' does not exist on type '... Remove this comment to see the full error message
    isAdmin: Boolean(user.worktangoAdmin),
    // @ts-expect-error TS(2339): Property 'isImpersonating' does not exist on type '{}'.
    isImpersonating: Boolean(user.isImpersonating),
    // @ts-expect-error TS(2339): Property 'updated' does not exist on type '{}'.
    updatedAt: new Date(user.updated * 1000).toString(),
    // @ts-expect-error TS(2339): Property 'created' does not exist on type '{}'.
    createdAt: new Date(user.created * 1000).toString(),
    companyId: company.id,
    companyLogoUrl: company?.logoUrl,
    companyColor: company?.color,
    companyName: company?.name,
    supportedLanguages: company?.supportedLanguages,
    workspace: company?.workspace,
    companyFeatureSettings: company?.companyFeatureSettings,
  };

  return {
    account,
    company,
  };
};

export { accountFrom };
